import { render, staticRenderFns } from "./WriteMouvement.vue?vue&type=template&id=fafc2686&"
import script from "./WriteMouvement.vue?vue&type=script&lang=js&"
export * from "./WriteMouvement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports